// extracted by mini-css-extract-plugin
module.exports = {"inlineUi":"style__inlineUi___3GJLs"};